import { Grid, Moment } from '@chipinside/frontend'
import { Translate } from '@chipinside/translate'
import { uniqueId } from 'lodash'
import React from 'react'

import Colors from '#/styles/Colors'

export default function JobDetailHeader(props) {
  const { queued_at, started_at, finished_at, name, summary } = props

  /*
   * Dialog Header
   * Creating an array of objects.
   */
  const items = [
    {
      label: Translate({ messageKey: 'queued_at' }),
      value: Moment.view(queued_at),
    },
    {
      label: Translate({ messageKey: 'started_at' }),
      value: Moment.view(started_at),
    },
    {
      label: Translate({ messageKey: 'finished_at' }),
      value: Moment.view(finished_at),
    },
  ]
  const success = summary?.success ?? 0
  const success_with_warnings = summary ? summary['success-with-warnings'] : 0
  const failed = summary?.failed ?? 0

  if (!name?.match('export')) {
    if (name === 'move-many-collars') {
      items.push(
        {
          label: Translate({
            messageKey: 'collar',
            params: { item: Translate({ messageKey: 'moved', lower: true }) },
          }),
          value: <b style={{ color: Colors.success }}>{success + success_with_warnings}</b>,
        },
        {
          label: Translate({
            messageKey: 'collar',
            params: {
              item: Translate({ messageKey: 'not_moved', lower: true }),
            },
          }),
          value: <b style={{ color: Colors.danger }}>{failed}</b>,
        },
      )
    } else {
      items.push(
        {
          label: Translate({ messageKey: 'processed_successfully' }),
          value: <b style={{ color: Colors.success }}>{success}</b>,
        },
        {
          label: Translate({ messageKey: 'processed_with_errors' }),
          value: <b style={{ color: Colors.warning }}>{success_with_warnings}</b>,
        },
        {
          label: Translate({ messageKey: 'unprocessed' }),
          value: <b style={{ color: Colors.danger }}>{failed}</b>,
        },
      )
    }
  }

  return (
    <Grid
      container
      spacing={1}
      sx={{
        mb: 2,

        justifyContent: { xs: 'flex-start', md: 'space-between' },
      }}
    >
      {items.map(item => {
        return (
          <Grid
            key={uniqueId()}
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              minWidth: 120,
              width: { xs: '100%', sm: 'initial' },
              flexDirection: 'column',
            }}
          >
            <label
              style={{
                color: '#9e9e9e',
                fontSize: '12px',
                whiteSpace: 'nowrap',
              }}
            >
              {item.label}
            </label>
            <span>{item.value}</span>
          </Grid>
        )
      })}
    </Grid>
  )
}
